<template>
  <div class="modifyLicense">
    <!--<h1>Modify License</h1>-->
    <h1 style="color:rgb(255, 99, 71);">
      <strong>Warning</strong>: <small>The current operation will change the existed license record.
      The new Expiry Date may make the license expired, new NE point changes required
      the customer to switch the new generated license file to take effect.</small>
    </h1>

    <el-card class="box-card">
      <h2>Modify License Form</h2>
      <el-form ref="newLicenseForm" label-position="left" :model="newLicenseForm" :rules="modifyRules" label-width="150px">
        <el-form-item label="License Type" style="text-align:left;">
          <el-radio :disabled=true v-model="newLicenseForm.lic_type" :label=0>Web</el-radio>
          <el-radio :disabled=true v-model="newLicenseForm.lic_type" :label=1>Local</el-radio>
        </el-form-item>
        <el-form-item label="Project Name" prop="project">
          <el-input v-model="newLicenseForm.project"></el-input>
        </el-form-item>
        <el-form-item label="Direct Customer" prop="direct_cus" style="text-align:left">
          <el-select v-model="newLicenseForm.direct_cus" filterable placeholder="Please Select" disabled
                     :filter-method="handleCustomerAutoComplete" @change="handleCustomerInputChange" @focus="getCustomerDataList">
            <el-option
              v-for="item in customerData.cus_list"
              :key="item.cus_id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Expiry Date [as UTC(+00:00)]" prop="exp_date">
          <el-col :span="11">
            <el-date-picker type="date" placeholder="Select Date" v-model="tmp_exp_date"
                            value-format="yyyy-MM-ddTHH:mm:ss.000Z"
                            @change="OnExpiryDateChange"
                            :disabled="datePickerDisable" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-checkbox v-model="checked" @change="OnCheckBoxChange">No Limit</el-checkbox>
        </el-form-item>
        <el-form-item label="Customer Email" prop="user_email">
          <el-input type="email" placeholder="Email Address" v-model="newLicenseForm.user_email" clearable disabled></el-input>
        </el-form-item>
        <el-form-item label="ER Number" prop="er_num" style="text-align:left">
          <el-select v-model="newLicenseForm.er_num" multiple filterable allow-create default-first-option placeholder="Enter ER Number">
            <el-option disabled
              v-for="item in er_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="NE Point" prop="ne_point">
          <el-input placeholder="NE Point" type="number" v-model="newLicenseForm.ne_point" clearable></el-input>
        </el-form-item>
        <el-form-item label="Enable White Label" prop="white_label" style="text-align:left">
          <el-checkbox v-model="newLicenseForm.white_label"></el-checkbox>
        </el-form-item>
        <el-form-item label="PI Number" prop="pi_num">
          <el-input v-model="newLicenseForm.pi_num"></el-input>
        </el-form-item>
        <el-form-item label="Support Duration" prop="support_dr" style="text-align:left">
          <el-input type="number" v-model="newLicenseForm.support_dr" min="0" style="width: 20%;"
                    @change="OnSupportDrChange"
                    @blur="OnSupportDrChange">
          </el-input>
          (years)
          <br><small style="text-align:left; color:slateblue;">
            {{ newLicenseForm.support_dr_date ? newLicenseForm.support_dr_date.format("DD MMM YYYY") : ''}}
          </small>
        </el-form-item>
        <el-form-item label="Sales Name" prop="sales">
          <el-input v-model="newLicenseForm.sales"></el-input>
        </el-form-item>
        <el-form-item label="Sales Email" prop="sales_email">
          <el-input v-model="newLicenseForm.sales_email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" plain @click="modifyLicense" :loading="modifying">Submit</el-button>
          <el-button type="info" plain @click="$router.go(-1)">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {getCustomerList, modifyLicense, searchCustomerAutoComplete} from '../api'
import moment from 'moment'
export default {
  name: 'ModifyLicense',
  data () {
    console.log(this.$route.params.data)
    return {
      modifying: false,
      checked: false,
      datePickerDisable: false,
      tmp_exp_date: null,
      jsonData: String,
      customerData: {},
      LicenseInfo: this.$route.params.data ? this.$route.params.data : [],
      newLicenseForm: {
        outerlicense: this.$route.params.data ? this.$route.params.data.outerlicense : '',
        interlicense: this.$route.params.data ? this.$route.params.data.interlicense : '',
        lic_type: this.$route.params.data ? this.$route.params.data.lic_type : 0,
        project: this.$route.params.data ? this.$route.params.data.project : '',
        direct_cus: this.$route.params.data ? this.$route.params.data.direct_cus : '',
        exp_date: this.$route.params.data ? this.$route.params.data.exp_date : 0,
        user_email: this.$route.params.data ? this.$route.params.data.user_email : '',
        cus_id: this.$route.params.data ? this.$route.params.data.cus_id : '',
        ne_point: this.$route.params.data ? this.$route.params.data.license_content.all_feature : 0,
        white_label: this.$route.params.data ? this.$route.params.data.license_content.white_label : false,
        er_num: [],
        pi_num: this.$route.params.data ? this.$route.params.data.pi_num : '',
        support_dr: this.$route.params.data ? this.$route.params.data.support_dr : 0,
        support_dr_date: this.$route.params.data ? this.$route.params.data.support_dr_date : 0,
        sales: this.$route.params.data ? this.$route.params.data.sales : '',
        sales_email: this.$route.params.data ? this.$route.params.data.sales_email : ''
      },
      create_date: this.$route.params.data ? this.$route.params.data.create_date : 0,
      er_options: [],
      modifyRules: {
        project: [
          { required: true, message: 'Please Enter Project Name', trigger: 'blur' }
        ],
        direct_cus: [
          { required: true, message: 'Please Enter Direct Customer Name', trigger: 'blur' }
        ],
        exp_date: [
          { type: 'date', required: true, message: 'Please Select a Expire Date', trigger: 'blur' }
        ],
        user_email: [
          { type: 'email', required: true, message: 'Please Enter a Valid Email Address', trigger: 'blur' }
        ],
        er_num: [
          { required: true, message: 'Please Enter ER Number', trigger: 'blur' }
        ],
        ne_point: [
          { required: true, message: 'Please Enter NE Point', trigger: 'blur' }
        ],
        sales_email: [
          { type: 'email', required: true, message: 'Please Enter a Valid Email Address', trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    this.checked = this.newLicenseForm.exp_date === -1
    this.datePickerDisable = this.checked

    if (!this.checked) {
      const tmp_date = new Date(this.newLicenseForm.exp_date);
      this.tmp_exp_date = tmp_date.toISOString()
    }

    // if support_dr is null, set to default 0
    if (!this.newLicenseForm.support_dr) {
      this.newLicenseForm.support_dr = 0
    }
    this.OnSupportDrChange(this.newLicenseForm.support_dr)

    if (this.$route.params.data) {
      // Convert er_num from String to Array
      this.newLicenseForm.er_num = this.$route.params.data.er_num.split(',')
      this.er_options = this.$route.params.data.er_num.split(',')
    }
  },
  methods: {
    OnCheckBoxChange (value) {
      let that = this

      console.log('OnCheckBoxChange - value = ')
      console.log(value)

      if (value === true) {
        that.newLicenseForm.exp_date = -1
        that.datePickerDisable = true
      } else {
        that.newLicenseForm.exp_date = null
        that.datePickerDisable = false
      }
    },
    OnSupportDrChange (value) {
      var tmpDate = moment.utc()

      console.log('OnSupportDrChange - support_dr = ')
      console.log(this.newLicenseForm.support_dr)

      tmpDate.add(this.newLicenseForm.support_dr, 'years')
      this.newLicenseForm.support_dr_date = tmpDate
    },
    OnExpiryDateChange (value) {
      var datum = Date.parse(value)
      this.newLicenseForm.exp_date = datum
    },
    getCustomerDataList (val) {
      let that = this
      console.log('getCustomerList val')
      console.log(val)

      getCustomerList().then(data => {
        console.log('getCustomerList Succeed')
        console.log(data)
        that.customerData = data
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
      })
    },
    handleCustomerAutoComplete (value) {
      const that = this
      console.log('handleCustomerAutoComplete --> value')
      console.log(value)
      searchCustomerAutoComplete(value).then(data => {
        console.log('searchCustomerAutoComplete Success -> data')
        console.log(data)
        that.customerData = data
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
      })
    },
    handleCustomerInputChange (val) {
      console.log('handleCustomerInputChange -> val')
      console.log(val)

      this.newLicenseForm.direct_cus = val.name
      this.newLicenseForm.cus_id = val.cus_id
      this.newLicenseForm.user_email = val.email
    },
    modifyLicense () {
      const that = this
      that.$refs.newLicenseForm.validate((valid) => {
        if (valid) {
          that.modifying = true
          console.log('newLicenseForm')
          console.log(that.newLicenseForm)
          that.jsonData = {'all_feature': parseInt(that.newLicenseForm.ne_point), 'white_label': that.newLicenseForm.white_label}
          Object.assign(that.newLicenseForm, {'license_content': that.jsonData})

          modifyLicense(that.newLicenseForm).then(data => {
            that.modifying = false
            console.log('modifyLicense Success')
            console.log('modifyLicense Success -> data.data')
            console.log(data.data)
            that.$router.push({name: 'CompleteLicense', params: {data: data.data}})
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.modifying = false
          })
          /* modifyCheckLicense(that.newLicenseForm).then(data => {
            that.modifying = false

            if(data.data.status == 1) {
              console.log('data.data.status == 1, Go to “Edit License Page Confirm” page ');
              this.$router.push({name: 'ConfirmLicense', params: {data: that.newLicenseForm}});
            } else {
              console.log('data.data.status != 1, "Modify License” directly');
              modifyLicense(that.newLicenseForm).then(data => {
                console.log('modifyLicense Success');
                console.log('modifyLicense Success -> data.data');
                console.log(data.data);
                this.$router.push({name: 'CompleteLicense', params: {data: data.data}});
              })
            }
          }).catch(error => {
            that.modifying = false
          }) */
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome{
  margin: 0px auto;
  max-width: 350px;
  position: relative;
  margin-top: 50px;
}
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// ModifyLicense.vue?724343d8